module.exports = __webpack_public_path__ + "media/theme/tutorial__mobage--1--redeem-d07d3b85.png";